import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/credentials/page';

export const Route = createFileRoute('/_app/settings/credentials/')({
  component: Page,
});
